<template>
  <a
    href="https://vk.com/video-224421721_456239066"
    target="_blank"
  >
    <img
      style="border-radius: 8px;"
      src='@/assets/images/banners/ww2-anniversary-80.png'
      alt="80-летию Победы посвящается"
    >
  </a>
</template>

<script>
export default {
  name: 'banner-ww2-anniversary-80',
}
</script>

<style>

</style>